import React from "react"
import {translate} from "translate"
import PropTypes from "prop-types"
import {Table} from "elemental"
import Price from "../Price/Price"

const CartTotal = ({sum, size}) => {
  return (
    <Table style={{maxWidth: "320px"}} className="fr">
      <thead>
      <tr>
        <td><strong>{translate("cart.positions")}</strong></td>
        <td className="tr">{size}</td>
      </tr>
      <tr>
        <td><strong>{translate("cart.subtotal")}</strong></td>
        <td className="tr"><Price>{sum}</Price></td>
      </tr>
      </thead>
    </Table>
  )
}

CartTotal.propTypes = {
  sum:  PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/components/Cart/CartTotal.js